// Imports
import ___CSS_LOADER_API_SOURCEMAP_IMPORT___ from "../../../../../node_modules/css-loader/dist/runtime/sourceMaps.js";
import ___CSS_LOADER_API_IMPORT___ from "../../../../../node_modules/css-loader/dist/runtime/api.js";
var ___CSS_LOADER_EXPORT___ = ___CSS_LOADER_API_IMPORT___(___CSS_LOADER_API_SOURCEMAP_IMPORT___);
// Module
___CSS_LOADER_EXPORT___.push([module.id, `.monthly-performance-pdf {
  height: 17%;
  width: 100%;
  margin-top: 0.5cm;
}
.monthly-performance-pdf__header {
  display: flex;
  flex-direction: row;
  justify-content: space-between;
  margin-bottom: 0.5cm;
  padding-left: 0.5cm;
}
.monthly-performance-pdf__header__title {
  font-size: 0.5cm;
  font-weight: 800;
  text-align: start;
}
.monthly-performance-pdf__content {
  width: 80%;
  height: 100%;
  padding-left: 0.5cm;
}
.monthly-performance-pdf__content .year {
  text-align: center;
}
.monthly-performance-pdf__content .achat-vente-table {
  overflow-x: auto;
}
.monthly-performance-pdf__content table {
  border-collapse: collapse;
  width: 50%;
}
.monthly-performance-pdf__content th,
.monthly-performance-pdf__content td {
  border: 0.0625rem solid #ddd;
  padding: 0.15cm;
  text-align: left;
  width: fit-content;
  font-size: 0.26cm;
  text-wrap: nowrap;
  height: 0.3cm;
}
.monthly-performance-pdf__content th:last-child,
.monthly-performance-pdf__content td:last-child {
  text-wrap: wrap;
}
.monthly-performance-pdf__content th {
  background-color: #4babb9;
  color: white;
  font-size: 0.3cm;
}
.monthly-performance-pdf__content th:first-child, .monthly-performance-pdf__content th:nth-child(2) {
  border-top: transparent;
  border-left: transparent;
  background-color: transparent;
}
.monthly-performance-pdf__content th:first-child {
  border-right: transparent;
}
.monthly-performance-pdf__content .bold {
  font-weight: bold;
}`, "",{"version":3,"sources":["webpack://./src/features/pdf/components/monthly-performance-pdf/monthly-performance-pdf.scss"],"names":[],"mappings":"AAAA;EACC,WAAA;EACA,WAAA;EACA,iBAAA;AACD;AAAE;EACE,aAAA;EACA,mBAAA;EACA,8BAAA;EACA,oBAAA;EACA,mBAAA;AAEJ;AAAI;EACI,gBAAA;EACA,gBAAA;EACA,iBAAA;AAER;AACE;EACI,UAAA;EACA,YAAA;EACA,mBAAA;AACN;AAAM;EACE,kBAAA;AAER;AAAM;EACI,gBAAA;AAEV;AACM;EACE,yBAAA;EACA,UAAA;AACR;AAEM;;EAEE,4BAAA;EACA,eAAA;EACA,gBAAA;EACA,kBAAA;EACA,iBAAA;EACA,iBAAA;EACA,aAAA;AAAR;AACQ;;EACE,eAAA;AAEV;AAEM;EACE,yBAAA;EACA,YAAA;EACA,gBAAA;AAAR;AACQ;EACE,uBAAA;EACA,wBAAA;EACA,6BAAA;AACV;AACQ;EACE,yBAAA;AACV;AAGM;EACE,iBAAA;AADR","sourcesContent":[".monthly-performance-pdf{\n height: 17%;\n width: 100%;\n margin-top: 0.5cm;\n  &__header{\n    display: flex;\n    flex-direction: row;\n    justify-content: space-between;\n    margin-bottom: 0.5cm;\n    padding-left: 0.5cm;\n\n    &__title{\n        font-size: 0.5cm;\n        font-weight: 800;\n        text-align: start;\n    }\n  }\n  &__content{\n      width: 80%;\n      height: 100%;\n      padding-left: 0.5cm;\n      .year{\n        text-align: center;\n      }\n      .achat-vente-table {\n          overflow-x: auto;\n        }\n        \n      table {\n        border-collapse: collapse;\n        width: 50%;\n      }\n      \n      th,\n      td {\n        border: 0.0625rem solid #ddd;\n        padding: 0.15cm;\n        text-align: left;\n        width: fit-content;\n        font-size: 0.26cm;\n        text-wrap: nowrap;\n        height: 0.3cm;\n        &:last-child {\n          text-wrap: wrap;\n        }\n      }\n      \n      th {\n        background-color: #4babb9;\n        color: white;\n        font-size: 0.3cm;\n        &:first-child, &:nth-child(2) {\n          border-top: transparent;\n          border-left: transparent;\n          background-color: transparent;\n        }\n        &:first-child {\n          border-right: transparent;\n        }\n      }\n      \n      .bold {\n        font-weight: bold;\n      }\n        \n  }\n}"],"sourceRoot":""}]);
// Exports
___CSS_LOADER_EXPORT___.locals = {};
export default ___CSS_LOADER_EXPORT___;
